// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  &.products-list-grid {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 15px;
    grid-row-gap: 24px;
    padding-top: 24px;
    border-bottom: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    padding-bottom: 7px;

    @media ${(props) => props.theme.mediaQuery.small} {
      grid-template-columns: repeat(auto-fill, minmax(163px, 1fr));
    }

    @media ${(props) => props.theme.mediaQuery.medium} {
      grid-column-gap: 32px;
      padding-top: 32px;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      grid-column-gap: 16px;
      grid-row-gap: 64px;
      grid-template-columns: repeat(auto-fill, minmax(264px, 1fr));
      padding-bottom: 19px;
    }
  }
`;
